export enum Months {
  January = "1",
  February = "2",
  March = "3",
  April = "4",
  May = "5",
  June = "6",
  July = "7",
  August = "8",
  September = "9",
  October = "10",
  November = "11",
  December = "12",
}

export const EMonthsTicket = {
  "01": "Jan",
  "02": "Feb",
  "03": "Mar",
  "04": "Apr",
  "05": "May",
  "06": "Jun",
  "07": "Jul",
  "08": "Aug",
  "09": "Sep",
  "10": "Oct",
  "11": "Nov",
  "12": "Dec",
};
export const swrOptions = {
  revalidateOnFocus: false,
  revalidateOnReconnect: false,
  shouldRetryOnError: false,
};

// export const BaseUrl = "https://eventeamapi.crag.dev";
export const BaseUrl = "https://api.eventeam.az";
